import { Col, Row, Select } from "antd";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";
import { ConnectionSequenceStepConnectionType } from "types/enums";

import { FormData } from "../formSchema";

const { Option } = Select;

export const FurtherStepSection: FC = () => {
    // const reqSetting = DrawerId.ResponseFurtherStepSetting;
    const { control, fieldNames, getValues } = useGeneralForm<FormData>();

    const steps = getValues("methods");

    return (
        <Row gutter={16} align="middle">
            <Col span={10}>
                {/* <FormItem control={control} name={`type`} label="Typ" labelCol={{ span: 24 }}> */}
                <Select
                    placeholder="Select a type"
                    className="w-full"
                    defaultValue={ConnectionSequenceStepConnectionType.GoToStep}
                >
                    <Option value={ConnectionSequenceStepConnectionType.GoToStep}>
                        {ConnectionSequenceStepConnectionType.GoToStep}
                    </Option>
                </Select>
                {/* </FormItem> */}
            </Col>

            <Col span={10}>
                <FormItem
                    control={control}
                    name={fieldNames.first_sequence_step_id?.name || "first_sequence_step_id"}
                    label="Akce"
                >
                    <Select placeholder="Select a source">
                        {steps?.map(({ name, id }) => (
                            <Option value={id} key={id}>
                                {name}
                            </Option>
                        ))}
                    </Select>
                </FormItem>
            </Col>

            {/* <Col>
                <DrawerLink
                    drawerId={reqSetting}
                    search={{
                        [`${reqSetting}-id`]: name.toString(),
                        [`${reqSetting}-propertyType`]: type,
                    }}
                    action="show"
                >
                    <Button icon={<SettingOutlined />} />
                </DrawerLink>
            </Col> */}
        </Row>
    );
};
